export default "__VITE_ASSET__CNoE8kTb__"